<template>
    <div class="vehicleInfoDiv" :class="[$store.getters.isLoggedIn ? 'auth' : '']">
        <div class="carDetailsDiv" v-if="!$store.getters.isMobile" :class="[$store.getters.isLoggedIn ? 'auth' : '']">
            <div v-for="(detail, index) in $store.getters.getAvailablSortColumnNames" :key="index" class="carDetail" :class="[$store.getters.isLoggedIn ? 'carDetailColumnAuth' : 'carDetailColumn']">
                <span v-if="['Miles', 'ACV', 'PriceToShow', 'BOB'].includes(detail)" @click="displayProposalLink(detail)"><!--" ? goToProposalLink  : {}"> -->
                    {{ formatNumber(car[detail], detail) }}
                </span>
                <span v-else>
                    {{ getCarDetail(detail) }}
                </span>
            </div>
        </div>
        <div v-else class="mobileCarDetails">
            <div class="mobileCarPrice" @click="displayProposalLink('PriceToShow')"><!--v-on="displayProposalLink(detail) ? { click : goToProposalLink() } : {}">-->
                {{ formatNumber(car['PriceToShow'], 'PriceToShow') }}
            </div>
            <div class="mobileCarDetailsDivider">
                &#8226;
            </div>
            <div class="mobileCarMiles">
                {{ formatNumber(car['Miles'], 'Miles') }} miles
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'car'
        ],
        computed: {
            proposalLink() {
                return this.$store.getters.getAppUrlByName('mycar') + "/component/textProposal/" + this.car['StockNumber'];
            }
        },
        methods: {
			classes (col) {
				return {
					current: this.$store.getters.getSortColumn === col
				}
            },
            displayProposalLink(detail) {
                if(detail == "PriceToShow") {
                    console.log("**** PRICE TO SHOW FOUND ****");
                    this.goToProposalLink();
                }
            },
            getCarDetail (detail) {
                if(detail != "Options") {
                    return (this.car[detail] && this.car[detail] != "None" ? this.car[detail] : "");
                }
                else {
                    let optionsList = ""

                    if(this.car.Moonroof && this.car.Moonroof == 1) {
                        optionsList += (optionsList ? "\n": "") + "Moonroof";
                    }

                    if(this.car.RearEntertainment) {
                        optionsList += (optionsList ? "\n" : "") + 'Rear Entertainment';
                    }

                    if(this.car.Nav && this.car.Nav == 1) {
                        optionsList += (optionsList ? "\n" : "") + "Navigation";
                    }

                    if(this.car.Leather && this.car.Leather == 1) {
                        optionsList += (optionsList ? "\n" : "") + "Leather";
                    }

                    if(this.car.bcamera && this.car.bcamera == 1) {
                        optionsList += (optionsList ? "\n" : "") + "Backup Camera";
                    }

                    if(this.car.CabType && this.car.CabType != "None") {
                        optionsList += (optionsList ? "\n" : "") + this.car.CabType;
                    }

                    if(this.car.thirdrow && this.car.thirdrow == 1) {
                        optionsList += (optionsList ? "\n" : "") + "Third Row";
                    }

                    if(this.car.Doors && this.car.Doors != "N") {
                        optionsList += (optionsList ? "\n" : "") + this.car.Doors + " Door";
                    }

                    return optionsList;
                }
            },
            formatNumber: function (num, type) {
                var numFormated = "";
                
                if(num) {
                    if(type == 'PriceToShow' || type == 'ACV' || type == 'BOB') {
                        numFormated = "$";
                    } 
                    
                    numFormated += num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                }
                else {
                    numFormated = 0;
                }
                
                return numFormated;
            },
            authRequired(detail) {
                return (this.$store.getters.isLoggedIn || !this.$store.getters.getAvailableSortColumns[detail].authRequired);
            },
            goToProposalLink() {
                console.log("GOTO PROPOSAL LINK");
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('open', {'event_category': 'text_proposal','event_label': eventLabel});
                this.$store.dispatch('openAppInSeperateWindow', this.proposalLink);
            }
        }
    }
</script>

<style>
    .vehicleInfoDiv {
        height: 100%;
        color:#666;
        width: calc(68 * var(--vw));
        display: flex;
    }

    .vehicleInfoDiv.auth {
        width: calc(68 * var(--vw));
    }

    .inmobile .vehicleInfoDiv {
        width: inherit;
        height: calc(4 * var(--vh))
    }

    .inmobile.tabletstyle .vehicleInfoDiv {
        width: fit-content;
    }

    .carDetailsDiv {
        width: calc(68 * var(--vw));
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em)); /*calc(.5vw + ((1 - var(--vratio)) * 1em));;*/
    }

    .inmobile .carDetailsDiv {
		font-size: calc(2.1 * var(--vh));
    }

    .mobileCarDetails {
        width: inherit;
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(4 * var(--vh));
    }

    .mobileCarDetailsDivider {
        margin: 0 calc(1.2 * var(--vw));
    }

    .carDetailsDiv.auth {
        width: calc(68 * var(--vw));
    }

    .carDetailColumn {
        width: calc((68/9) * var(--vw));
    }

    .carDetailColumnAuth {
         width: calc((68/11) * var(--vw));
    }

    .carDetail {
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>